import { Collection } from 'modules/core/lib/mobx-rest'

import CalendarEvent from 'modules/calendar/store/models/CalendarEvent'

class CalendarEvents extends Collection<CalendarEvent> {
  get cacheKey(): string {
    return 'calendarEvents'
  }

  model() {
    return CalendarEvent
  }
}

const singleton: CalendarEvents = new CalendarEvents()

export default singleton
